import { useCallback } from 'react'

import { DrawingParameterMeasurementLabel, DrawingType } from '@editor/interfaces/drawing'
import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { BLUEPRINT_TOOL_LABELS } from '@editor/pages/projects/blueprint-editor/constants'
import { removeDrawings } from '@editor/pages/projects/blueprint-editor/store/drawings'
import { getDrawingsOfType } from '@editor/services/Drawing'
import { RootState, useAppDispatch } from '@editor/store/app'
import { resetElement } from '@editor/store/tool'
import { useSelector } from 'react-redux'

const useDrawingsPanel = (): ElementsPanelConfig => {
  // Store
  const dispatch = useAppDispatch()
  const drawings = useSelector((state: RootState) => state.blueprint.drawings.document.drawings)
  const workingElementId = useSelector((state: RootState) => state.toolUtil.core.workingElementId)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item']): EditorPanelItem[] => {
        if (parent) return [] as EditorPanelItem[]

        return getDrawingsOfType<DrawingParameterMeasurementLabel>(drawings, DrawingType.MeasurementLabel, []).map(
          (item, index) => ({
            key: `tool-text-annotation-${item.drawing_parameters.uuid}`,
            name: item.name || `${BLUEPRINT_TOOL_LABELS['measurement-label']} ${index + 1}`,
            item,
            isWorking: item.drawing_parameters.uuid === workingElementId,
            onDelete: () => {
              dispatch(removeDrawings([item.drawing_parameters.uuid]))
              dispatch(resetElement(item.drawing_parameters.uuid))
            },
          }),
        )
      },
      [drawings, workingElementId, dispatch],
    ),
  }
}

export default useDrawingsPanel
